<template>
    <div class="modal fade" id="user-activity-log-modal" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>

                    <h4 class="modal-title">USER ACTIVITY LOG FOR: {{ userName }}</h4>
                </div>
                <div class="modal-body">
                    <div class="pull-left" style="overflow: hidden">

                        <date-picker
                            v-if="!loading"
                            v-model="range"
                            placeholder="Select Date Range"
                            lang="en"
                            range-separator="-"
                            :format="format"
                            :value-type="'YYYY-MM-DD'"
                            :range="true"
                            :confirm="false"
                            prefix-class="xmx"
                            @change="changeDate"
                        />

                        <br><br>
                    </div>
                    <a class="pull-right btn btn-circle btn-icon-only btn-default" :href="getExportUrl()">
                        <i class="icon-cloud-download"></i>
                    </a>
                    <div class="clearfix"></div>
                    <spinner v-if="loading"></spinner>
                    <template v-else>
                        <vue-good-table :columns="columns"
                                        :rows="rows"
                                        :pagination-options="{'enabled': false}">
                            >
                            <div slot="emptystate">
                                No logs available.
                            </div>
                        </vue-good-table>
                        <pagination
                                :page-count="pages"
                                :page-range="1"
                                :margin-pages="1"
                                :initialPage="page - 1"
                                :click-handler="changePage"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination pagination-sm'">
                        </pagination>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Spinner from "@/components/Spinner";
    import Breadcrumbs from "../components/Breadcrumbs";
    import Pagination from '@/components/Pagination.vue'
    import {HTTP, URL, getUserInfo} from "../http-common";
    import DatePicker from 'vue2-datepicker';

    export default {

        components: {
            Pagination,
            Spinner,
            DatePicker,
            'breadcrumb-bar': Breadcrumbs
        },

        props: ['id'],

        data() {
            return {
                loading: false,
                userName: '',
                logs: [],
                columns: [
                    {
                        label: 'Timestamp',
                        field: 'date',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Message',
                        field: 'message',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Account',
                        field: 'account_name',
                        filterOptions: {enabled: true}
                    }
                ],
                range: ['', ''],
                from: '',
                to: '',
                page: 1,
                pages: 1,
                results: 0
            }
        },

        computed: {
            rows() {
                return this.logs.map(item => {
                    item.date = this.$options.filters.formatDate(item.date.date);
                    return item;
                });
            },
            format() {
                return getUserInfo('date_format')
            },
        },

        mounted() {
            if (this.id) {
                this.fetchUserActivityLog();
                $('#user-activity-log-modal').modal('show');
            }

            $('#user-activity-log-modal').on('hidden.bs.modal', () => {
                this.logs = [];
                this.page = 1;
                this.$emit('hide');
            });
        },

        methods: {
            fetchUserActivityLog(params) {
                this.loading = true;
                HTTP.get('user-activity-log/get/' + this.id, {params: params}).then(response => {
                    if (response.data.status == 'success') {
                        this.logs = response.data.data.logs;
                        this.userName = response.data.data.user_name;
                        this.pages = response.data.data.pages;
                        this.results = response.data.data.results;
                    }
                }).catch(err => {
                    this.$notify({type: 'error', text: 'Can\'t get log activity data.'});
                    this.$emit('hide');
                    console.log(err)
                }).then(() => {
                    this.loading = false;
                })
            },
            changeDate() {
                this.fetchUserActivityLog({from: this.range[0], to: this.range[1], page: 1});
            },
            changePage(page) {
              this.page = page;
              this.fetchUserActivityLog({from: this.range[0], to: this.range[1], page: this.page});
            },
            getExportUrl() {
                return `${URL}/user-activity-log/export?id=${(this.id)}&from=${this.range[0]}&to=${this.range[1]}&token=${localStorage.getItem('id_token')}`
            }

        },

        inject: {
            $validator: '$validator'
        },
    }
</script>

<style scoped>
    .pagination {
        display: flex;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// UserActivityLogModal.vue?609e440d